import React, { useCallback, useEffect, useRef, useState } from 'react'
import DashboardLayout from '../../../layouts/DashboardLayout/DashboardLayout'
import PageTitle from '../../../components/PageTitle'
import { Helmet } from 'react-helmet/es/Helmet'
import { systemName } from '../../../config'
import { Tabs } from 'antd'
const { TabPane } = Tabs
// Component
// Style Component
import {
  SelectList,
  SelectTitle,
} from '../../MissionCreatePage/MissionCreatePageStyled'
import {
  ButtonFooter,
  UploadFileListItem,
  UploadFileListWrapper,
} from './WorkUpdatePageStyled'
// Ant design
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Steps,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import {
  BankOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PaperClipOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
// Other
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
  ISO_DATE_FORMAT,
} from '../../../constants'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../../components/Common/Avatar'
import { blue, redPrimary, yellowPrimary } from '../../../color'
import RichEditor from '../../../components/RichEditor/RichEditor'
import { useLocation, useHistory, useParams } from 'react-router-dom'
import authenticationStore from '../../../stores/authenticationStore'
import queryString from 'query-string'
import utils from '../../../utils'
import validator from '../../../validator'
import {
  CustomStepIcon,
  StepsWrapper,
} from '../../Documents/InternalDocumentSignDocPage/PopupUpdateSignDoc/PopupUpdateSignDocStyled'

const { Step } = Steps
const { Option } = Select

const WorkUpdatePage = props => {
  const {
    selectPeopleStore,
    fileStore,
    workStore,
    loadingAnimationStore,
  } = props

  const history = useHistory()
  const { code_work } = useParams()

  useEffect(() => {
    if (!workDetail || workDetail.code !== code_work) {
      workStore.getWorkDetail(code_work)
    }
  }, [code_work])

  const { Option } = Select
  const [form] = Form.useForm()

  const { currentUser } = authenticationStore

  const { workDetail, workList, workListV2 } = workStore
  const { workTypeList, queryParams } = workStore

  const {
    assignees,
    attachments,
    content,
    due_date,
    start_date,
    title,
    work_type,
    permission,
  } = workDetail

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const EDITOR_REF = useRef(null)

  const location = useLocation()
  const queryStringParsed = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  const isElectronicWork = work_type === WORK_STATUS.ELECTRONIC

  const [fileUploadedList, setFileUploadedList] = useState([])
  const [fileList, setFileList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [leaderList, setLeaderList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [creator, setCeator] = useState([])
  const [departmentApproverList, setDepartmentApproverList] = useState([])
  const [formApproverList, setFormApproverList] = useState([])
  const [leaderApproverList, setLeaderApproverList] = useState([])
  const [numberIssuerList, setNumberIssuerList] = useState([])
  const [digitalSignerList, setDigitalSignerList] = useState([])
  const [releaserList, setReleaserList] = useState([])

  const [stepsData, setStepsData] = useState([])

  useEffect(() => {
    if (assignees) {
      const creator = assignees.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission === ASSIGNEE_TYPE.CREATE
      )
      setCeator(creator)
    }
  }, [assignees])

  useEffect(() => {
    if (!permission) {
      return
    }
    const allowedPermissions = Array.isArray(permission) ? permission : (typeof permission === 'string' ? permission.split(',') : [])

    const allSteps = [
      {
        key: 1,
        title: 'Tạo dự thảo',
        userList:
          creator && creator.length > 0
            ? [
                {
                  image_id: creator[0].image,
                  full_name: creator[0].name_uppercase,
                },
              ]
            : [],

        allowDeleted: false,
      },
      {
        key: 2,
        title: 'Trưởng phòng duyệt',
        userList: departmentApproverList || [],
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
        permission: 'DEPARTMENT_APPROVER',
      },
      {
        key: 3,
        title: 'Duyệt thể thức',
        userList: formApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
        permission: 'FORM_APPROVER',
      },
      {
        key: 4,
        title: 'Lãnh đạo duyệt',
        userList: leaderApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
        permission: 'LEADER_APPROVER',
      },
      {
        key: 5,
        title: 'Ký số điện tử',
        userList: digitalSignerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        permission: 'DIGITAL_SIGNER',
      },
      {
        key: 6,
        title: 'Phát hành',
        userList: releaserList || [],
        type: 'approval',
        allowDeleted: false,
        assignee_type: ASSIGNEE_TYPE.RELEASER,
        permission: 'RELEASER',
      },
    ]

    const filteredSteps = allSteps.filter(
      step => !step.permission || allowedPermissions.includes(step.permission)
    )

    setStepsData(filteredSteps)
  }, [
    releaserList,
    currentUser,
    departmentApproverList,
    formApproverList,
    leaderApproverList,
    numberIssuerList,
    digitalSignerList,
    permission,
    creator,
  ])

  const userList = assignees
    ? assignees.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []
  const departmentList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT)
    : []
  const groupList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.GROUP)
    : []
  useEffect(() => {
    if (isElectronicWork) {
      setDepartmentApproverList([
        ...(selectUserData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
        ...(selectDepartmentData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
        ...(selectGroupData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ])

      setFormApproverList([
        ...(selectUserData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
        ...(selectDepartmentData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
        ...(selectGroupData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ])

      setLeaderApproverList([
        ...(selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
        ...(selectDepartmentData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
        ...(selectGroupData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ])

      setDigitalSignerList([
        ...(selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
        ...(selectDepartmentData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
        ...(selectGroupData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ])

      setReleaserList([
        ...(selectUserData[ASSIGNEE_TYPE.RELEASER] || []),
        ...(selectDepartmentData[ASSIGNEE_TYPE.RELEASER] || []),
        ...(selectGroupData[ASSIGNEE_TYPE.RELEASER] || []),
      ])
    } else {
      setHandlerList([
        ...selectUserData[ASSIGNEE_TYPE.HANDLER],
        ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
        ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
      ])
      setFollowerList([
        ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
        ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
        ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
      ])
      setCombinerList([...selectUserData[ASSIGNEE_TYPE.COMBINER]])
      setLeaderList([...selectUserData[ASSIGNEE_TYPE.LEADER]])
    }
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (isElectronicWork) {
      if (
        selectUserData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.FORM_APPROVER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.RELEASER].length === 0
      ) {
        selectPeopleStore.setSelectUserData(
          selectPeopleStore.convertSelectDataObj(userList)
        )
      }
      if (
        selectDepartmentData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER].length === 0 &&
        selectDepartmentData[ASSIGNEE_TYPE.FORM_APPROVER].length === 0 &&
        selectDepartmentData[ASSIGNEE_TYPE.LEADER_APPROVER].length === 0 &&
        selectDepartmentData[ASSIGNEE_TYPE.RELEASER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER].length === 0
      ) {
        selectPeopleStore.setSelectDepartmentData(
          selectPeopleStore.convertSelectDataObj(departmentList)
        )
      }

      if (
        selectGroupData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER].length === 0 &&
        selectGroupData[ASSIGNEE_TYPE.FORM_APPROVER].length === 0 &&
        selectGroupData[ASSIGNEE_TYPE.DIGITAL_SIGNER].length === 0 &&
        selectGroupData[ASSIGNEE_TYPE.RELEASER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER].length === 0
      ) {
        selectPeopleStore.setSelectGroupData(
          selectPeopleStore.convertSelectDataObj(groupList)
        )
      }
    } else {
      if (
        selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
        selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
      ) {
        selectPeopleStore.setSelectUserData(
          selectPeopleStore.convertSelectDataObj(userList)
        )
      }

      if (
        selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
        selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
      ) {
        selectPeopleStore.setSelectDepartmentData(
          selectPeopleStore.convertSelectDataObj(departmentList)
        )
      }

      if (
        selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
        selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
      ) {
        selectPeopleStore.setSelectGroupData(
          selectPeopleStore.convertSelectDataObj(groupList)
        )
      }
    }
  }, [originDepartmentWithUserList])

  useEffect(() => {
    form.setFieldsValue({
      work_type: work_type,
      title: title,
      start_date: start_date && moment(start_date),
      due_date: due_date && moment(due_date),
    })
    setFileUploadedList(attachments)
  }, [workDetail])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const onFinish = async value => {
    const code_work = workDetail?.code
    const new_items_assign = []
    const remove_items_assign = []
    const listAssignOrigin = [...userList, ...departmentList, ...groupList].map(
      el => ({
        assignee_code: el.assignee_code,
        assignee_type: el.assignee_type,
        permission: el.permission,
      })
    )
    const listAssignAfter = isElectronicWork
      ? [
          ...departmentApproverList,
          ...formApproverList,
          ...leaderApproverList,
          ...numberIssuerList,
          ...digitalSignerList,
          ...releaserList,
        ].map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))
      : [...followerList, ...handlerList, ...combinerList, ...leaderList].map(
          el => ({
            assignee_code: el.id,
            assignee_type: el.assignee_type,
            permission: el.permission,
          })
        )
    if (handlerList.length === 0 && !isElectronicWork) {
      message.info('Bạn chưa chọn người xử lý!')
      return
    }
    listAssignAfter.forEach(assignAfter => {
      if (
        !listAssignOrigin.some(
          assignOrigin =>
            assignOrigin.assignee_code + assignOrigin.permission ===
            assignAfter.assignee_code + assignAfter.permission
        )
      ) {
        new_items_assign.push({
          assignee_code: assignAfter.assignee_code,
          assignee_type: assignAfter.assignee_type,
          permission: assignAfter.permission,
        })
      }
    })
    listAssignOrigin.forEach(assignOrigin => {
      if (
        !listAssignAfter.some(
          assignAfter =>
            assignAfter.assignee_code + assignAfter.permission ===
            assignOrigin.assignee_code + assignOrigin.permission
        )
      ) {
        remove_items_assign.push({
          assignee_code: assignOrigin.assignee_code,
          assignee_type: assignOrigin.assignee_type,
          permission: assignOrigin.permission,
        })
      }
    })

    const { title, start_date, due_date, work_type } = value
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    const permission = stepsData
      .filter(el => el.key !== 1)
      .map(el => el.permission)
      .join(',')

    try {
      loadingAnimationStore.showSpinner(true)
      const response = await Promise.all(batchUploadArr)
      const dataSubmit = {
        title: title,
        start_date: start_date,
        due_date: due_date,
        content: EDITOR_REF.current.editor.getData(),
        attachments: response
          .map(response => response.data.file_id)
          .concat(fileUploadedList.map(file => file.file_id)),
        assignees: {
          new_items: new_items_assign,
          remove_items: remove_items_assign,
        },
        current_assignees: listAssignAfter,
        code: code_work,
        work_type: work_type,
        permission: permission,
      }
      await workStore.updateWork(code_work, dataSubmit)
      await workStore.getWorkDetail(code_work)
      setFileList([])
      selectPeopleStore.clearSelected()
      history.replace('/works')
      message.success('Cập nhật công việc thành công!')
    } catch (err) {
      console.log(err)
      message.error('Chỉ người xử lý mới có quyền cập nhật công việc!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const {
    title: titleReset,
    start_date: startDateReset,
    due_date: dueDateReset,
  } = form.getFieldsValue(['title', 'start_date', 'due_date'])

  const handleCancel = () => {
    setFileList([])
    setFileUploadedList(attachments)
    selectPeopleStore.clearSelected()
    form.setFieldsValue({
      title: titleReset,
      start_date:
        startDateReset &&
        moment(moment(startDateReset).format(ISO_DATE_FORMAT)),
      due_date:
        dueDateReset && moment(moment(dueDateReset).format(ISO_DATE_FORMAT)),
    })
    EDITOR_REF.current.editor.setData(EDITOR_REF.current?.props.data)
    history.replace('/works')
  }

  const handleRemoveStep = useCallback(
    key => {
      const newStepsData = stepsData.filter(step => step.key !== key)
      setStepsData(newStepsData)
    },
    [stepsData]
  )

  const existingStepKeys = useCallback(() => {
    return stepsData.map(step => step.key)
  }, [stepsData])

  const allSteps = [
    {
      key: 1,
      title: 'Tạo dự thảo',
      userList:
        creator && creator.length > 0
          ? [
              {
                image_id: creator[0].image,
                full_name: creator[0].name_uppercase,
              },
            ]
          : [],
      allowDeleted: false,
    },
    {
      key: 2,
      title: 'Trưởng phòng duyệt',
      userList: departmentApproverList ? departmentApproverList : [],
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      permission: 'DEPARTMENT_APPROVER',
    },
    {
      key: 3,
      title: 'Duyệt thể thức',
      userList: formApproverList ? formApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
      permission: 'FORM_APPROVER',
    },
    {
      key: 4,
      title: 'Lãnh đạo duyệt',
      userList: leaderApproverList ? leaderApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
      permission: 'LEADER_APPROVER',
    },
    {
      key: 5,
      title: 'Ký số điện tử',
      userList: digitalSignerList ? digitalSignerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
      permission: 'DIGITAL_SIGNER',
    },
    {
      key: 6,
      title: 'Phát hành',
      userList: releaserList ? releaserList : [],
      type: 'approval',
      allowDeleted: false,
      assignee_type: ASSIGNEE_TYPE.RELEASER,
      permission: 'RELEASER',
    },
  ]

  const handleAddStep = useCallback(
    key => {
      if (!key) return
      const stepToAdd = allSteps.find(step => step.key === key)
      if (stepToAdd) {
        setStepsData(prev => {
          const newSteps = [...prev, stepToAdd]
          newSteps.sort((a, b) => a.key - b.key)
          return newSteps
        })
      }
    },
    [allSteps]
  )

  const renderTitleStep = level => {
    return (
      <>
        <div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>{level.title}</span>
            {level.key !== 1 && (
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ marginLeft: 8 }}
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(level.assignee_type)
                  }
                />
              </Tooltip>
            )}
          </div>
        </div>
      </>
    )
  }

  const renderDescStep = level => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: level.allow_edit ? 6 : 14,
          marginBottom: 14,
        }}>
        {level.userList[0] ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag
              className={'tag-selected'}
              color={'blue'}
              closable={level.key === 1 ? false : true}
              onClose={() =>
                selectPeopleStore.handleRemoveSelect(level.userList[0])
              }>
              <AvatarHasName
                imgId={level.userList[0]?.image_id}
                size={22}
                name={level.userList[0]?.full_name}
              />
            </Tag>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag style={{ borderRadius: 10 }}>Chưa gán người!</Tag>
          </div>
        )}
      </div>
    )
  }

  return (
    
      <DashboardLayout>
      <Helmet>
        <title>Cập nhật công việc | {systemName} Công việc</title>
      </Helmet>
      <PageTitle location={location} />
      
      <div style={{ padding: '0 24px', maxWidth: '100%' }}>
        <h2 style={{ fontSize: 24, fontWeight: 600, marginBottom: 24, color: '#262626' }}>
          Cập nhật công việc
        </h2>

        <Form onFinish={onFinish} form={form} layout="vertical">
          <div style={{ 
            background: '#fafafa', 
            borderRadius: 8, 
            padding: 24, 
            marginBottom: 24,
            border: '1px solid #f0f0f0' 
          }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: '#262626' }}>
              Thông tin chung
            </h3>
        <Form.Item
          style={{ display: 'none' }}
          label={'Loại công việc'}
          name={'work_type'}
          rules={[{ required: true, message: 'Vui lòng chọn loại công việc' }]}>
          <Select
            className={isElectronicWork && 'ant-disabled'}
            placeholder={'-- Chọn loại công việc --'}>
            {workTypeList.map(workType => (
              <Option
                disabled={isElectronicWork}
                key={workType.id}
                value={workType.id}
                name={workType.name}>
                {workType.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={'Tiêu đề:'}
          name={'title'}
          rules={[
            { required: true, message: 'Vui lòng nhập tiêu đề' },
            { validator: validator.validateInputString },
          ]}>
          <Input
            className={isElectronicWork && 'ant-disabled'}
            disabled={isElectronicWork}
            placeholder={'Nhập tiêu đề...'}
          />
        </Form.Item>

        </div><div style={{ background: '#fff', borderRadius: 8, padding: '0', border: '1px solid #f0f0f0' }}>
            <Tabs defaultActiveKey="1" style={{ padding: '0 24px' }}>
              <TabPane tab="Nội dung" key="1">
                <Form.Item label={'Nội dung:'} name={'content'}>
          <RichEditor
            EDITOR_REF={EDITOR_REF}
            placeholder={'Nhập nội dung...'}
            editorContent={content && content}
          />
        </Form.Item>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={'Ngày bắt đầu:'}
              rules={[
                { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
              ]}
              name={'start_date'}>
              <DatePicker format={DATE_FORMAT_LIST} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={'Ngày kết thúc:'}
              name={'due_date'}
              rules={[
                { required: false, message: 'Vui lòng chọn ngày kết thúc!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const startDate = getFieldValue('start_date')
                    if (!startDate || !value) {
                      //! Không thực hiện kiểm tra nếu ngày bắt đầu hoặc ngày kết thúc không có giá trị
                      return Promise.resolve()
                    }
                    if (value.isAfter(startDate)) {
                      //! Ngày kết thúc lớn hơn ngày bắt đầu
                      return Promise.resolve()
                    }
                    //! Ngày kết thúc không hợp lệ
                    return Promise.reject(
                      'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                    )
                  },
                }),
              ]}>
              <DatePicker format={DATE_FORMAT_LIST} />
            </Form.Item>
          </Col>
        </Row>
        {isElectronicWork ? (
          <>
            <div>
              <Select
                placeholder="Chọn bước để thêm"
                value={null}
                onChange={value => {
                  handleAddStep(value)
                }}
                style={{ width: 300 }}>
                {allSteps
                  .filter(item => item.allowDeleted)
                  .map(step => (
                    <Option
                      key={step.key}
                      value={step.key}
                      disabled={existingStepKeys().includes(step.key)}>
                      {step.title}
                    </Option>
                  ))}
              </Select>
            </div>

            <StepsWrapper count={stepsData.length} i={4}>
              <Steps
                status="process"
                className={'steps'}
                labelPlacement={'vertical'}
                size={'small'}>
                {stepsData.map(level => {
                  return (
                    <Step
                      key={level.level}
                      title={renderTitleStep(level)}
                      description={renderDescStep(level)}
                      icon={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <CustomStepIcon>{level.key} </CustomStepIcon>
                          {level.allowDeleted && (
                            <CloseOutlined
                              style={{ marginLeft: 6, fontSize: 12 }}
                              onClick={() => handleRemoveStep(level.key)}
                            />
                          )}
                        </div>
                      }
                    />
                  )
                })}
              </Steps>
            </StepsWrapper>
          </>
        ) : (
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <SelectTitle>
                <span>
                  <span
                    style={{
                      color: '#ff4d4f',
                      fontFamily: 'SimSun, sans-serif',
                      marginRight: '-4px',
                    }}>
                    *{' '}
                  </span>
                  <span style={{ marginRight: '10px' }}>
                    {isElectronicWork ? 'Lãnh đạo ký duyệt:' : 'Người xử lý:'}
                  </span>
                </span>
                <Space>
                  <Tooltip title="Chọn người dùng" color={blue}>
                    <Button
                      icon={<UserOutlined style={{ color: blue }} />}
                      onClick={() =>
                        handleOpenSelectUserDepartmentPopup(
                          ASSIGNEE_TYPE.HANDLER
                        )
                      }
                    />
                  </Tooltip>
                  {!isElectronicWork && (
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={() =>
                          handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                        }
                      />
                    </Tooltip>
                  )}
                </Space>
              </SelectTitle>
              <SelectList>
                {handlerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>

            <Col span={12}>
              <SelectTitle>
                <span>
                  <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
                </span>
                <Space>
                  <Tooltip title="Chọn người dùng" color={blue}>
                    <Button
                      icon={<UserOutlined style={{ color: blue }} />}
                      onClick={() =>
                        handleOpenSelectUserDepartmentPopup(
                          ASSIGNEE_TYPE.FOLLOWER
                        )
                      }
                    />
                  </Tooltip>
                  <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                    <Button
                      icon={<TeamOutlined />}
                      style={{ color: yellowPrimary }}
                      onClick={() =>
                        handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                      }
                    />
                  </Tooltip>
                </Space>
              </SelectTitle>
              <SelectList>
                {followerList.map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
              </SelectList>
            </Col>
          </Row>
        )}
              </TabPane>
              <TabPane tab="Tài liệu đính kèm" key="2">
                <Form.Item label={'Chọn file đính kèm:'} name={'id_file_dinh_kem'}>
          <Upload
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}>
            <Button htmlType={'button'}>
              <UploadOutlined />
              Chọn files đính kèm
            </Button>
          </Upload>
        </Form.Item>
        {fileList.length !== 0 && (
          <UploadFileListWrapper>
            {fileList.map((file, index) => (
              <UploadFileListItem key={file.uid}>
                <PaperClipOutlined />
                <span>{file.name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() => handleRemoveFileFromUploadList(file.uid)}
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
        {fileUploadedList && fileUploadedList.length !== 0 && (
          <UploadFileListWrapper>
            {fileUploadedList.map(file => (
              <UploadFileListItem key={file.file_id}>
                <PaperClipOutlined />
                <span>{file.file_name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      setFileUploadedList(
                        fileUploadedList.filter(
                          el => el.file_id !== file.file_id
                        )
                      )
                    }
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
              </TabPane>
            </Tabs>
        </div>
          
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32, paddingBottom: 40, gap: 16 }}>
            <Button
              size="large"
              style={{ minWidth: 120, borderRadius: 8, color: '#ff4d4f', borderColor: '#ff4d4f' }}
              onClick={() => handleCancel()}
            >
              Hủy
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              style={{ minWidth: 120, borderRadius: 8 }}
            >
              Cập nhật
            </Button>
          </div>
        </Form>
        <style>{`
          .ant-tabs-nav::before {
            border-bottom: 1px solid #f0f0f0;
          }
          .ant-tabs-tab {
            font-weight: 500;
          }
        `}</style>
      </div>
      <SelectPeoplePopup
        onlyOneUser={
          isElectronicWork
            ? selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
            : false
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </DashboardLayout>
  )
}

WorkUpdatePage.propTypes = {}

export default inject(
  'selectPeopleStore',
  'fileStore',
  'workStore',
  'loadingAnimationStore'
)(observer(WorkUpdatePage))
